import { ComponentHeader, StyledDashboard } from "@components";
import { logout, selectAuth, setLoading } from "@redux";
import { checkPermissions, useNotify, useclinicHcp } from "@utils";

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  ClientInfo,
  ClinicCircleCount,
  ClinicCount,
  CouponChart,
  CouponCount,
  PatientCircleCount,
  PatientNew,
  PatientRecord,
  PatientTotal,
} from "src/Modules/Dashboard";
import { useClientInfo, useCouponCount, useCouponInfo, useclinicGraph } from "@utils";
import { Select } from "antd";
import { region_towship } from "@configs";
import { range_filter } from "@configs";

export const PageHome: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { auth } = useSelector(selectAuth);
  checkPermissions();

  const region_names = Object.keys(region_towship);
  const client = useClientInfo();
  const [patientFilter, setFilter] = useState(range_filter[0]);
  const [region, setRegion] = useState(region_names[2]);
  const [couponRegion, setCouponRegion] = useState(region_names[2]);
  const coupons = useCouponCount({ type: patientFilter });
  const info = useCouponInfo({ region });
  const clinic = useclinicGraph({ region: couponRegion });
  const hcp = useclinicHcp();

  useEffect(() => {
    try {
      dispatch(setLoading(true));
    } catch (err: any) {
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  }, []);
  const handleFilter = (value: string) => {
    setFilter(value);
  };
  const handleFilterRegion = (value: string) => {
    setRegion(value);
  };
  const handleFilterClinic = (value: string) => {
    setCouponRegion(value);
  };
  return (
    <>
      <ComponentHeader title={t("page.dashboard")} />
      <div style={{ padding: "16px 0 0 38px" }}>
        <Select
          defaultValue="MNCH"
          style={{ minWidth: 160 }}
          options={[
            { value: "MNCH", label: "MNCH" },
            { value: "CDIC", label: "CDIC", disabled: true },
          ]}
        />
      </div>
      <StyledDashboard>
        <PatientCircleCount patient={coupons} />
        <section className="middle-layout">
          <PatientNew patient={coupons} patientFilter={patientFilter} handleFilter={handleFilter} />
          <PatientTotal patient={coupons} />
          <PatientRecord patient={coupons} />
        </section>
        <CouponCount coupon={coupons} />
        <CouponChart clinic={clinic} region={couponRegion} handleFilterRegion={handleFilterClinic} />
        <ClientInfo client={client} />
        <ClinicCircleCount patient={hcp} />
        <ClinicCount info={info} region={region} handleFilterRegion={handleFilterRegion} />
      </StyledDashboard>
    </>
  );
};
